import { useLang } from "../i18n/LanguageContext";

const CHEF_IMAGE =
  "https://images.unsplash.com/photo-1775513153018-0c7ac7899751?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxmaW5lJTIwZGluaW5nJTIwY2hlZiUyMHBsYXRpbmclMjBmb29kJTIwaGFuZHN8ZW58MHx8fHwxNzc5MjE4ODc1fDA&ixlib=rb-4.1.0&q=85";

const INGREDIENT_IMAGE =
  "https://images.unsplash.com/photo-1604908815571-1ec53eb2c1e2?auto=format&fit=crop&w=1200&q=80";

export const BrandStory = () => {
  const { t } = useLang();

  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative py-24 md:py-36 bg-[#f9f6f0]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section head */}
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-3 flex items-start gap-3">
            <span className="editorial-divider mt-3" />
            <span className="overline" data-testid="story-overline">
              {t.story.overline}
            </span>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2
              data-testid="story-title"
              className="font-serif-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-[#2c1e16] whitespace-pre-line"
            >
              {t.story.title}
            </h2>
          </div>
        </div>

        {/* Asymmetric editorial body */}
        <div className="grid grid-cols-12 gap-6 md:gap-12 items-start">
          {/* Left: copy */}
          <div className="col-span-12 md:col-span-7 space-y-7 md:space-y-9">
            <p className="font-serif-display text-2xl md:text-3xl leading-snug text-[#2c1e16] italic">
              {t.story.lead}
            </p>
            <p className="text-base md:text-lg leading-relaxed text-[#2c1e16]/75">
              {t.story.p1}
            </p>

            {/* Pull quote */}
            <blockquote className="relative my-10 md:my-14 pl-6 border-l-2 border-[#a64b2a]">
              <p className="font-serif-display text-2xl md:text-3xl italic text-[#2c1e16] leading-snug">
                {t.story.pull}
              </p>
              <footer className="mt-4 font-mono-utility text-[11px] tracking-[0.25em] uppercase text-[#5b664f]">
                {t.story.signature}
              </footer>
            </blockquote>

            <p className="text-base md:text-lg leading-relaxed text-[#2c1e16]/75">
              {t.story.p2}
            </p>
            <p className="text-base md:text-lg leading-relaxed text-[#2c1e16]/75">
              {t.story.p3}
            </p>
          </div>

          {/* Right: images, sticky overlap */}
          <div className="col-span-12 md:col-span-5 md:sticky md:top-28">
            <div className="relative">
              <div className="zoom-frame rounded-sm overflow-hidden border border-[#e5d9c5]">
                <img
                  src={CHEF_IMAGE}
                  alt="Chef plating gourmet dish"
                  className="w-full h-[420px] md:h-[520px] object-cover"
                  data-testid="story-image-chef"
                />
              </div>
              <div className="hidden md:block absolute -bottom-16 -left-12 w-52 zoom-frame rounded-sm overflow-hidden border border-[#e5d9c5] bg-[#f9f6f0]">
                <img
                  src={INGREDIENT_IMAGE}
                  alt="Spices and herbs close-up"
                  className="w-full h-52 object-cover"
                  data-testid="story-image-ingredients"
                />
              </div>
              <div className="mt-6 flex items-center justify-between font-mono-utility text-[10px] tracking-[0.25em] uppercase text-[#5b664f]">
                <span>FIG. 01 · The hand at work</span>
                <span>Baden, 2026</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
